var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayNewMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.125C8.78555 2.125 2.125 8.78555 2.125 17C2.125 25.2145 8.78555 31.875 17 31.875C25.2145 31.875 31.875 25.2145 31.875 17C31.875 8.78555 25.2145 2.125 17 2.125ZM17 29.3516C10.1801 29.3516 4.64844 23.8199 4.64844 17C4.64844 10.1801 10.1801 4.64844 17 4.64844C23.8199 4.64844 29.3516 10.1801 29.3516 17C29.3516 23.8199 23.8199 29.3516 17 29.3516Z",
    fill: "#4b4a52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8863 16.5721L14.0549 9.43344C13.976 9.37564 13.8827 9.34087 13.7852 9.33301C13.6878 9.32515 13.5901 9.3445 13.503 9.38891C13.4159 9.43332 13.3428 9.50104 13.2919 9.58453C13.2411 9.66802 13.2144 9.764 13.2148 9.86176V24.1391C13.2148 24.5741 13.7063 24.8198 14.0549 24.5675L23.8863 17.4288C23.9542 17.3799 24.0095 17.3155 24.0476 17.2411C24.0858 17.1666 24.1056 17.0841 24.1056 17.0005C24.1056 16.9168 24.0858 16.8343 24.0476 16.7599C24.0095 16.6854 23.9542 16.621 23.8863 16.5721ZM15.3332 21.0214V12.9795L20.8682 17.0005L15.3332 21.0214Z",
    fill: "#C09E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayNewMobile);
export default __webpack_public_path__ + "static/media/play_new_mobile.7e32a034.svg";
export { ForwardRef as ReactComponent };